export const PREVIEWER_CONTENT = {
  helpMessage: 'Save and preview for accurate character count.',
};

export const WEB_PUSH_NON_WINDOWS_TITLE_LIMIT = 40;
export const WEB_PUSH_NON_WINDOWS_BODY_LIMIT = 100;
export const WEB_PUSH_WINDOWS_TITLE_LIMIT = 50;
export const WEB_PUSH_WINDOWS_BODY_LIMIT = 120;
export const CLICK_LOCATION_LIMIT = 30;

// export const OS_WITH_IMAGE_SUPPORT = [OSWebPush.Android.toString(), OSWebPush.Windows.toString()];

const TEMPLATE_EDITOR_WEB_PUSH = 'template-editor-web-push';
export const TEMPLATE_EDITOR_WEB_PUSH_PREVIEW_PANE_ID = `${TEMPLATE_EDITOR_WEB_PUSH}-preview-pane`;
export const TEMPLATE_EDITOR_WEB_PUSH_PLATFORM_SELECTOR = `${TEMPLATE_EDITOR_WEB_PUSH}-platform-selector`;
export const TEMPLATE_EDITOR_WEB_PUSH_TITLE = `${TEMPLATE_EDITOR_WEB_PUSH}-title`;
export const TEMPLATE_EDITOR_WEB_PUSH_BODY = `${TEMPLATE_EDITOR_WEB_PUSH}-body`;
export const PREVIEW_REFRESH_BUTTON = 'web-push-preview-refresh-button';
export const HELP_MESSAGE = 'web-push-help-message';
export const TEMPLATE_EDITOR_WEB_PUSH_PREVIEW_FOOTER = 'template-editor-web-push-preview-footer';
